import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { EMessageType } from 'src/app/shared/data/response-default.interface';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { ToastService } from 'src/app/shared/services/toast.service';
import { IPerfilAcesso } from '../../roles/models/role';
import { comPerfilLegado, perfisDoUsuario } from 'src/app/shared/utilities/perfis-do-usuario';
import { AtendenteService } from '../services/atendente.service';

@Component({
  selector: 'app-edit-atendente',
  templateUrl: './edit-atendente.component.html',
  styleUrls: ['./edit-atendente.component.scss']
})
export class EditAtendenteComponent implements OnInit {
  ERoleAdminString = ERoleAdminString;
  atendenteId?: string | null;

  formAtendente = new UntypedFormGroup({
    id: new UntypedFormControl('', [Validators.required]),
    fullName: new UntypedFormControl('', [Validators.required]),
    document: new UntypedFormControl('', [Validators.required]),
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    adminUserProfileIds: new UntypedFormControl([], [Validators.required]),
    accountRole: new UntypedFormControl(null),
    // Sem campo na tela, mas o PUT precisa deles: o account exige empresa para atendente e
    // grava companyId/partnerId como vierem (sem isso a edição nunca salvava).
    companyId: new UntypedFormControl(null),
    partnerId: new UntypedFormControl(null)
  });

  opcoesPerfilAcesso: IPerfilAcesso[] = [];

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly atendentesService: AtendenteService,
    private readonly toastService: ToastService
  ) {}

  public ngOnInit(): void {
    this.atendenteId = this.activatedRoute.snapshot.paramMap.get('id');

    if (this.atendenteId) {
      this.carregarDetalhesAtendente(this.atendenteId);
    }
  }

  getListPerfilAcesso(): void {
    this.atendentesService.listarPerfisComPermissaoAtendente().subscribe((resposta) => {
      this.opcoesPerfilAcesso = resposta.data;
    });
  }

  public carregarDetalhesAtendente(atendenteId: string): void {
    this.formAtendente.get('id')!.patchValue(atendenteId);

    this.atendentesService.detalheAtendente(atendenteId).subscribe((res) => {
      if (res.messages && res.messages.length > 0) {
        this.toastService.toast(res.messages);
      }
      this.formAtendente.get('id')!.patchValue(res.data.id);
      this.formAtendente.get('fullName')!.patchValue(res.data.fullName);
      this.formAtendente.get('document')!.patchValue(res.data.document);
      this.formAtendente.get('email')!.patchValue(res.data.email);
      this.formAtendente.get('adminUserProfileIds')!.patchValue(perfisDoUsuario(res.data));
      this.formAtendente.get('accountRole')!.patchValue(res.data.accountRole);
      this.formAtendente.get('companyId')!.patchValue(res.data.companyId);
      this.formAtendente.get('partnerId')!.patchValue(res.data.partnerId ?? null);

      this.getListPerfilAcesso();
    });
  }

  public editarAtendente(): void {
    if (this.formAtendente.valid) {
      const atendente = comPerfilLegado({
        ...this.formAtendente.getRawValue(),
        isAttendant: true
      });

      this.atendentesService.editarAtendente(atendente).subscribe({
        next: (res) => {
          if (res.messages && res.messages.length > 0) {
            this.toastService.toast(res.messages);
          }

          if (res.isSucceed) {
            this.router.navigateByUrl('/dash/atendentes');
          }
        },
        // o account devolve erro de negócio com 200; aqui só chega falha de rede/gateway
        error: () =>
          this.toastService.toast('Não foi possível atualizar o atendente. Tente novamente.', EMessageType.Error)
      });
    }
  }
}
